// extracted by mini-css-extract-plugin
export default {"bottom-navigation":"bottom-navigation___vnrwe","active":"active___LMaut","default":"default___QMdS6"};